import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  overflow: scroll;
  height: 100vh;
  background-color: ${props => props.theme.colors.background};

  grid-template-areas:
    'AS MH'
    'AS CT';
`;

export const Content = styled.div`
  grid-area: CT;
  background-color: ${props => props.theme.colors.background} !important;
  margin-left: ${props => props.theme.spacing.xxl};
  margin-right: ${props => props.theme.spacing.xxl};
  margin-top: 150px;
`;

const fadeInOut = keyframes`
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
`;

export const LoadingImageWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadingImageStyled = styled.img`
  max-width: 30%;
  animation: ${fadeInOut} 1.5s linear infinite;
`;
